export default __webpack_public_path__ + "static/media/logo.370b2eee.png";